import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { ReactComponent as DashboardSVG } from 'assets/images/dashboard.svg'
import { ReactComponent as NotificationsSVG } from 'assets/images/notifications.svg'

import { Tooltip } from 'components/tooltip'

import { GlobalState } from 'store'
import { openAdminMenu, closeAdminMenu } from 'store/admin/actions'
import { closeDocumentsMenu } from 'store/documents/actions'
import {
  openNotificationMenu,
  closeNotificationMenu
} from 'store/notification/actions'

import { UserType } from 'types/enums/UserType'
import {
  DASHBOARD_PAGE,
  CONTEST_LIST_PAGE,
  INSTITUTION_LIST_PAGE,
  SETTINGS_PAGE,
  PRECEDENTS_PAGE
} from 'navigation/paths'

import { HeaderWrapper, HeaderUser } from './styled'

export function Header(): JSX.Element {
  const { t } = useTranslation('common')
  const location = useLocation()
  const dispatch = useDispatch()

  const { user } = useSelector((state: GlobalState) => state.session)

  const { notifications } = useSelector(
    (state: GlobalState) => state.notification
  )

  const ActualRoute = useMemo(() => {
    if (location.pathname.startsWith(CONTEST_LIST_PAGE)) return 'Disputas'
    else if (location.pathname.startsWith(INSTITUTION_LIST_PAGE))
      return 'Instituições'
    else if (location.pathname.startsWith(PRECEDENTS_PAGE)) return 'Precedentes'
    else if (location.pathname.startsWith(SETTINGS_PAGE)) return 'Configurações'
    else return 'Dashboard'
  }, [location.pathname])

  const canAccessAdmin = useMemo(() => user?.type === UserType.ADMIN, [user])

  const userRole = useMemo(() => {
    switch (user?.type) {
      case 'ADMIN':
        return 'Administrador'
      case 'LOCAL':
        return 'Usuário'
      case 'DIRECTORY':
        return 'Diretório'
      case 'PRECEDENT':
        return 'Câmara'
      case 'PRECEDENT_REVIEWER':
        return 'Revisor'
      default:
        return ''
    }
  }, [user])

  return (
    <HeaderWrapper>
      <h1>{ActualRoute}</h1>
      <nav>
        {canAccessAdmin && (
          <Tooltip content={t('header.admin')}>
            <button
              type="button"
              onClick={() => {
                dispatch(closeNotificationMenu())
                dispatch(closeDocumentsMenu())
                dispatch(openAdminMenu())
              }}
            >
              <DashboardSVG />
            </button>
          </Tooltip>
        )}

        <Tooltip content={t('header.notifications')}>
          <button
            type="button"
            onClick={() => {
              dispatch(closeAdminMenu())
              dispatch(closeDocumentsMenu())
              dispatch(openNotificationMenu())
            }}
            data-count={notifications.length}
          >
            <NotificationsSVG />
          </button>
        </Tooltip>
        <HeaderUser>
          <div>
            <strong>{user?.name}</strong>
            <p>{userRole}</p>
          </div>
        </HeaderUser>
      </nav>
    </HeaderWrapper>
  )
}
